import React, { useMemo, useState } from 'react';
import type { ProtocolRecord } from '../types';

interface Props {
  protocols: ProtocolRecord[];
  selectedIds: Set<string>;
  onToggle: (protocolId: string) => void;
  onClose: () => void;
}

const ManageProtocolsModal: React.FC<Props> = ({ protocols, selectedIds, onToggle, onClose }) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return protocols;
    return protocols.filter(p =>
      p.name.toLowerCase().includes(q) ||
      p.id.toLowerCase().includes(q) ||
      p.section.toLowerCase().includes(q)
    );
  }, [protocols, search]);

  return (
    <div className="resus-admin__modal-overlay" onClick={onClose}>
      <div className="resus-admin__modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="resus-admin__modal__title">שיוך לפרוטוקולים</h3>
        <p className="resus-admin__field-hint">
          סמנו את הפרוטוקולים שבהם תופיע התרופה. תוכלו לשנות סדר ולהוסיף הערות בשלב 3.
        </p>

        <input
          className="resus-admin__search"
          type="search"
          placeholder="חיפוש פרוטוקול..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: 12 }}
        />

        <div className="resus-admin__modal__list">
          {filtered.length === 0 && <p className="resus-admin__subtle">אין פרוטוקולים תואמים.</p>}
          {filtered.map(p => {
            const checked = selectedIds.has(p.id);
            return (
              <label key={p.id} className="resus-admin__modal__list-row">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => onToggle(p.id)}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600 }}>{p.name || <em>(ללא שם)</em>}</div>
                  <div className="resus-admin__subtle" style={{ fontSize: '0.8rem' }}>{p.section}</div>
                </div>
              </label>
            );
          })}
        </div>

        <div className="resus-admin__modal__actions">
          <button type="button" className="resus-admin__btn resus-admin__btn--primary" onClick={onClose}>סגירה</button>
        </div>
      </div>
    </div>
  );
};

export default ManageProtocolsModal;
